import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setProviderList } from 'src/store/modules/admin'

import {
  GET_PATCH_DELETE_PROVIDER,
  GET_PROVIDER_LIST,
  POST_PROVIDER,
  PROVIDER_MANAGMENT_DELETE_MESSAGE,
  PROVIDER_MANAGMENT_SAVE_MESSAGE,
  PROVIDER_MANAGMENT_UPDATE_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const fetchProviderList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_PROVIDER_LIST,
          ...config
        }
      })

      dispatch(setProviderList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const saveProvider =
  (config = {}) =>
  async () => {
    try {
      await httpClient.request({
        method: 'post',
        url: { pathname: POST_PROVIDER },
        ...config
      })

      showSuccessModal({
        content: PROVIDER_MANAGMENT_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateProvider =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_PATCH_DELETE_PROVIDER,
          params
        },
        payload
      })

      showSuccessModal({
        content: PROVIDER_MANAGMENT_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteProvider =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: GET_PATCH_DELETE_PROVIDER,
          params
        },
        payload
      })

      showSuccessModal({
        content: PROVIDER_MANAGMENT_DELETE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
